export function BranchesService (BranchesLite, inheritorApi) {
  var Branches = function () {
    inheritorApi.inherit(this, BranchesLite);
  }

  inheritorApi.bootstrap(Branches, BranchesLite);

  return new Branches();
}
